import React, { FC } from "react";
import styles from "./SelfAttendance.module.scss";

interface PracticeRow {
  practice_date: string;
  status: string; // present | absent | od | unmarked
}

export interface EventAttendance {
  event_id: number;
  concert_name: string;
  practices: PracticeRow[];
}

interface SelfAttendanceProps {
  data: EventAttendance[];
}

const STATUS_LABEL: Record<string, string> = {
  present: "Present",
  absent: "Absent",
  od: "On Duty",
  unmarked: "Unmarked",
};

const statusClass = (status: string): string => {
  if (status === "present") return styles.SelfAttendance__badge_present;
  if (status === "absent") return styles.SelfAttendance__badge_absent;
  return styles.SelfAttendance__badge_unmarked; // unmarked / od
};

const formatDate = (iso: string): string => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

const SelfAttendance: FC<SelfAttendanceProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className={styles.SelfAttendance__empty}>No attendance records available.</div>;
  }

  return (
    <div className={styles.SelfAttendance}>
      {data.map((ev) => (
        <div className={styles.SelfAttendance__event} key={ev.event_id}>
          <h3 className={styles.SelfAttendance__concert}>{ev.concert_name}</h3>
          <table className={styles.SelfAttendance__table}>
            <thead>
              <tr>
                <th>Practice Date</th>
                <th>Attendance</th>
              </tr>
            </thead>
            <tbody>
              {ev.practices.map((p, i) => (
                <tr key={i}>
                  <td>{formatDate(p.practice_date)}</td>
                  <td>
                    <span className={`${styles.SelfAttendance__badge} ${statusClass(p.status)}`}>
                      {STATUS_LABEL[p.status] || p.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default SelfAttendance;
